// extracted by mini-css-extract-plugin
module.exports = {"container":"bottom-bar-shop_container__wG5Bm"};